import * as React from "react"
import {graphql} from 'gatsby'
import Layout from "../../components/layout";
import Seo from "../../components/seo";
import '../../styles/soutien.scss';


export default function Soutien({data}) {
    if (!data) return undefined
    const document = data.allPrismicSoutien
        .nodes[0];

    return (
        <Layout>
            <Seo title={document.data.titre}/>
            <section>
                <div className='soutien'>
                    <h2 className='subtitle is-5'>Publié
                        le {new Date(document.last_publication_date).toLocaleDateString(
                            'fr-FR',
                            {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                                timeZone: 'utc'
                            }
                        )}</h2>
                    <hr className='title-divider'/>
                    <h1 className='title'>{document.data.titre}</h1>
                    <div className='embed'
                         dangerouslySetInnerHTML={{__html: document.data.video.html}}/>
                </div>
            </section>
        </Layout>
    )
}

export const query = graphql`
query SoutienQuery($id: String) {
  allPrismicSoutien(filter: {id: {eq: $id}}) {
    nodes {
      last_publication_date
      data {
        titre
        video {
          html
        }
      }
    }
  }
}
`
